import styles from "./LoginPageDecorationSection.module.css"
import Image from "next/image";

import Model_a from "public/images/LoginPage/Model_a.png";
import Button from "@view/common/Components/Button";
import classNames from "classnames";
import { Lumni_Logo } from "@view/common/Components/Icons/Lumni_Logo";
import { Arrow } from "@view/common/Components/Icons/Arrow";

export interface IStartFundingPageDecorationSectionProps {
  title?: string;
  description?: string;
  subTitle?: string;
  className?: string;
}

const PreonboardingPageDecorationSection = (props: IStartFundingPageDecorationSectionProps) => {
  return (
    <section className={classNames(styles.root, props.className)}>
      <div className={styles.logoPartA}>
        <Lumni_Logo className={styles.lumniLogo} fillColor="#F9F9F9" />
      </div>
      <div className={styles.logoPartB}>
        <Lumni_Logo className={styles.lumniLogo} fillColor="#F9F9F9" />
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.separator} />
          <Lumni_Logo className={styles.lumniLogoMini} fillColor="#F9F9F9" />
        </div>
        <div className={styles.description}>
          <h1 className={styles.title}>¡Da el primer paso hacia tu futuro con salones llenos!</h1>
          <h2 className={styles.subTitle}>Regístrate y descubre oportunidades que pueden cambiar tu vida.</h2>
        </div>
        <div className={styles.header}>
          <div className={styles.buttons}>
            <Button variant="plain" className={styles.button}><Arrow className={styles.arrowLeft} /></Button>
            <Button variant="plain" className={styles.button}><Arrow className={styles.arrowRight} /></Button>
          </div>
          <div className={styles.separator} />
        </div>
        <div style={{display:"contents"}}>
          <img className={styles.backgroundImage} src={"https://lumni-public.s3.us-west-2.amazonaws.com/images_for_platform/Model_a_1.png"} alt="Person" />
        </div>
      </div>
    </section>
  )
};

export default PreonboardingPageDecorationSection;
